module.exports = __webpack_public_path__ + "static/media/we-are-august-2.8dc840e3.jpg";